import React from 'react';

import Header from './Header';
import MainNavigation from './MainNavigation';

const Layout = (props) => {
  return (
    <>
      <Header menu={props.menu} />
      <main>{props.children}</main>
    </>
  );
};

export default Layout;
